import { createCRUDHook } from './createCRUDHook';
import { PartMultiplierDto } from 'utils/models';
import { TBL_PART_MULTIPLIER } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<PartMultiplierDto>({
  entityName: 'PartMultiplier',
  endpoint: TBL_PART_MULTIPLIER,
});

export const PartMultiplierContext = Context;
export const usePartMultiplierManager = useManager;
export const usePartMultiplier = useConsumer;
